import React, {PureComponent} from 'react';
import Language from 'services/Language.js';
import ModalFixed from "./ModalFixed";
import {popupName} from "./ModalOperationConfirmation";

import {CodeSendHandlersIds} from 'constant/CodeSendHandlersIds';

/*
    HANDLER_SMS: 1,
    HANDLER_GOOGLE: 2,
    HANDLER_WORD: 3,
    HANDLER_EMAIL: 4,
    HANDLER_PASSWORD: 5,
    HANDLER_CAPTCHA: 6,
    HANDLER_GOOGLE_CAPTCHA: 7,
    HANDLER_WHATS_APP: 8
*/

class ModalConfirmMethodsForm extends PureComponent {

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      prevProps: null,
      isInvalid: false,
      isShowTelegramInstruction: false
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.state.text) {
      this.refs.input.refs.input.focus();
      this.setState({
        isInvalid: true,
      });
      return;
    }
    this.props.onSubmit({
      text: this.state.text,
      handlerId: this.props.handlerId,
    });
  }

  handleChange(event) {
    this.setState({
      text: event.target.value,
    });
  }


  static getDerivedStateFromProps(props, state) {
    const prevProps = state.prevProps;
    const prevState = state.prevState;

    return {
      prevProps: props,
      prevState: state
    };
  }

  getTabIndex() {
    return this.props.disableTabs ? "-1" : "";
  }

  getPending() {
    return !!this.props.pending;
  }

  render() {
    const {isShowTelegramInstruction} = this.state;

    return (
      <div data-backdrop="true"
           id={popupName}
           data-autofocus-first-input={true}
           className="modal modal-new modal-verification-new fade">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content js-form-wrapper">
            <div className="modal-header">
              <div className="modal-verification-new__top-actions">
                {
                  isShowTelegramInstruction ? (
                    <div
                      className="text text--size-body-small text--color-gray modal-verification-new__link text-action"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault()
                        if (isShowTelegramInstruction) {
                          this.setState({isShowTelegramInstruction: false})
                        }
                      }}>{Language.getLabel('L_BACK')}
                    </div>
                  ) : (
                    <a className="text text--size-body-small text--color-gray modal-verification-new__link text-action"
                       href="/login">
                      {Language.getLabel('L_BACK')}
                    </a>
                  )
                }
                <a className="btn-new btn-new--icon modal-new__close" href="javascript:void(0);" data-dismiss="modal">
                  <svg className="icon icon--close" id="icon--close" viewBox="0 0 24 24"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.99629 4.85076C5.38681 4.46024 6.01998 4.46024 6.4105 4.85076L19.2658 17.7061C19.6564 18.0966 19.6564 18.7298 19.2658 19.1203L19.0945 19.2916C18.704 19.6821 18.0709 19.6821 17.6803 19.2916L4.825 6.43627C4.43447 6.04574 4.43447 5.41258 4.825 5.02206L4.99629 4.85076Z"/>
                    <path
                      d="M4.85215 19.1203C4.46162 18.7298 4.46162 18.0966 4.85215 17.7061L17.7075 4.85075C18.098 4.46023 18.7312 4.46023 19.1217 4.85075L19.293 5.02205C19.6835 5.41257 19.6835 6.04574 19.293 6.43626L6.43765 19.2916C6.04713 19.6821 5.41396 19.6821 5.02344 19.2916L4.85215 19.1203Z"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="popup-slides">
              <div className="modal-body popup-slide-form">

                {isShowTelegramInstruction ? (
                  <div className="modal-verification-new__group">
                    <div className="modal-verification-new__info-tm" id="telegramInfo">
                    
                      <p className="text modal-verification-new__header-text">
                        {Language.getLabel('L_CONFIRM_HEADER_TELEGRAM_TITLE')}
                      </p>

                      <p className="text text--size-body-medium ">
                        {Language.getLabel('L_TELEGRAM_INTEGRATION_START', {
                          botName: this.props.settings.handlersData[CodeSendHandlersIds.HANDLER_TELEGRAM].botName
                        })}
                      </p>

                      <div className="modal-verification-new__body-img modal-verification-new__body-img-mb">
                        <img src="/img/modal-confirm-telegram-bot.svg" alt="modal-img" />
                      </div>

                      <p className="text text--size-body-medium text--color-blue">
                        <a className="text--size-button modal-verification-new__link btn-new" target='_blank'
                           href={'https://t.me/' + this.props.settings.handlersData[CodeSendHandlersIds.HANDLER_TELEGRAM].botName}>
                            {Language.getLabel('L_TELEGRAM_INTEGRATION_START3', {
                              botName: this.props.settings.handlersData[CodeSendHandlersIds.HANDLER_TELEGRAM].botName
                            })}
                        </a>
                      </p>
                      <div className="modal-verification-new__divider"></div>
                      <p className="text text--size-body-medium">
                        {Language.getLabel('L_TELEGRAM_INTEGRATION_START2', {
                          botName: this.props.settings.handlersData[CodeSendHandlersIds.HANDLER_TELEGRAM].botName
                        })}
                      </p>

                      <a className="modal-verification-new__link text text--size-button text--color-blue" href="#"
                         onClick={(e) => {
                           this.props.onHandleSelectMethod(e, 'telegram')
                         }}>
                        {Language.getLabel('L_CONTINUE')}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="modal-verification-new__img-verification">
                      <img src="/img/main/img-modal-verification.svg" alt="img-verification"/>
                    </div>
                    <div className="modal-verification-new__content" ref="container">
                      <h2
                        className="modal-verification-new__title text text--size-body-large">{Language.getLabel("L_SELECT_METHOD_SENDING_VERIFICATION_CODE")}</h2>
                      <form onSubmit={this.handleSubmit} className="modal-verification-new__form">
                        {/* {this.props.settings.useHandlers && this.props.settings.useHandlers[CodeSendHandlersIds.HANDLER_WHATS_APP] &&
                                            <div className="modal-verification-new__group">
                                                <button className="btn-new btn-new--block"
                                                    type="button"
                                                    disabled={this.getPending()}
                                                    tabIndex={this.getTabIndex()}
                                                    onClick={(e) => {
                                                        this.props.onHandleSelectMethod(e, 'whatsapp')
                                                    }}>
                                                    {Language.getLabel('L_WHATS_APP_CODE')}
                                                </button>
                                            </div>
                                        } */}
                        {this.props.settings.useHandlers && this.props.settings.useHandlers[CodeSendHandlersIds.HANDLER_TELEGRAM] &&
                          <div className="modal-verification-new__group">
                            <button className="btn-new btn-new--block"
                                    type="button"
                                    disabled={this.getPending()}
                                    tabIndex={this.getTabIndex()}
                                    onClick={(e) => {
                                      if (this.props.settings.handlersData[CodeSendHandlersIds.HANDLER_TELEGRAM].isExistLinkWithTelegram) {
                                        // если для указанного номера телефона уже есть привязка к телеграм, то сразу делаем запрос на бек
                                        this.props.onHandleSelectMethod(e, 'telegram')
                                      } else {
                                        // если для указанного номера телефона нет привязки к телеграм, то вначале показываем инструкцию
                                        e.preventDefault();
                                        this.setState({isShowTelegramInstruction: true})
                                      }
                                    }}>
                              <svg className="icon icon--telegram" width="25" height="24" viewBox="0 0 25 24"
                                   fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M21.15 4.1052L3.43388 10.6219C2.22482 11.0851 2.23182 11.7285 3.21205 12.0154L7.7605 13.3689L18.2843 7.03519C18.7819 6.74638 19.2365 6.90175 18.8628 7.21819L10.3365 14.5584H10.3345L10.3365 14.5594L10.0227 19.0315C10.4824 19.0315 10.6852 18.8304 10.943 18.5931L13.1523 16.5438L17.7477 19.7817C18.595 20.2268 19.2036 19.998 19.4144 19.0334L22.431 5.47202C22.7398 4.29107 21.9584 3.75635 21.15 4.1052Z"
                                  fill="white"/>
                              </svg>

                              Telegram
                            </button>
                          </div>
                        }
                        {this.props.settings.useHandlers && this.props.settings.useHandlers[CodeSendHandlersIds.HANDLER_SMS] &&
                          <React.Fragment>
                            <div className="modal-verification-new__group">
                              <button className="btn-new btn-new--block"
                                      type="button"
                                      disabled={this.getPending()}
                                      tabIndex={this.getTabIndex()}
                                      onClick={(e) => {
                                        this.props.onHandleSelectMethod(e, 'sms')
                                      }}>
                                <svg className="icon icon--sms" width="25" height="24" viewBox="0 0 25 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <g clipPath="url(#clip0_1401_2741)">
                                    <path
                                      d="M22.5 8.25387V17.2C22.5 18.7467 21.2632 20 19.7368 20H5.26316C4.53032 20 3.8275 19.705 3.30931 19.1799C2.79112 18.6548 2.5 17.9426 2.5 17.2V8.25387L12.1832 13.6512C12.3805 13.7611 12.62 13.7611 12.8168 13.6512L22.5 8.25333V8.25387ZM19.7368 4C20.4581 4.00007 21.1508 4.28595 21.6669 4.79657C22.183 5.3072 22.4816 6.00209 22.4989 6.7328L12.5 12.3061L2.50105 6.73227L2.50211 6.68427C2.53158 5.96227 2.83537 5.27978 3.34995 4.77951C3.86453 4.27924 4.55005 3.99993 5.26316 4H19.7368Z"
                                      fill="white"/>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1401_2741">
                                      <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                                    </clipPath>
                                  </defs>
                                </svg>

                                {Language.getLabel('L_SEND_SMS')}
                              </button>
                            </div>
                          </React.Fragment>
                        }
                        {this.props.settings.useHandlers
                          && this.props.settings.useHandlers[CodeSendHandlersIds.HANDLER_SMS]
                          && !this.props.settings.useHandlers[CodeSendHandlersIds.HANDLER_FLASHCALL] &&
                          <React.Fragment>
                            <div className="modal-verification-new__group">
                              <button className="btn-new btn-new--block"
                                      type="button"
                                      disabled={this.getPending()}
                                      tabIndex={this.getTabIndex()}
                                      onClick={(e) => {
                                        this.props.onHandleSelectMethod(e, 'call')
                                      }}>
                                <svg className="icon icon--call" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <path
                                      d="M3.89489 2.58107C4.96482 1.98434 6.32917 1.84452 7.63338 2.1741C8.26857 2.33389 8.81105 2.74461 9.13679 3.31014L10.2618 5.26513C10.6628 5.9621 10.7786 6.78631 10.5852 7.56622C10.3917 8.34614 9.90391 9.02168 9.22324 9.45225L8.23349 10.0789C7.82381 10.3374 7.67347 10.7331 7.76743 11.0464C8.10319 12.1675 8.84613 13.4109 9.66298 14.2623C9.90603 14.517 10.352 14.5769 10.788 14.3235L11.3355 14.0051C11.6948 13.7965 12.0921 13.6612 12.5044 13.6072C12.9166 13.5532 13.3356 13.5815 13.7367 13.6905C14.1379 13.7995 14.5133 13.987 14.841 14.2421C15.1686 14.4971 15.4421 14.8147 15.6453 15.1761L16.6538 16.9676C16.9833 17.5543 17.0372 18.2547 16.8042 18.8851C16.3394 20.1373 15.4436 21.1472 14.3424 21.6528C13.2236 22.1659 11.9143 22.1447 10.7292 21.357C8.85239 20.1111 6.59101 18.0138 4.54261 14.5157C2.46791 10.9703 1.94547 7.95292 2.00435 5.70331C2.04194 4.26391 2.80617 3.1878 3.89489 2.58107ZM15.411 2.10668C15.2658 2.02623 15.0945 2.00654 14.9347 2.05196C14.775 2.09738 14.6398 2.20418 14.5591 2.34887C14.4783 2.49356 14.4586 2.66429 14.5042 2.82349C14.5498 2.98269 14.6569 3.11733 14.8021 3.19778L15.2832 3.46494C16.7862 4.29688 18.0646 5.47904 19.0093 6.9104C19.954 8.34175 20.5368 9.97974 20.708 11.6844L20.7481 12.0776C20.7529 12.1618 20.7747 12.2441 20.8122 12.3197C20.8497 12.3952 20.9022 12.4624 20.9665 12.5172C21.0308 12.572 21.1056 12.6132 21.1864 12.6384C21.2671 12.6636 21.3521 12.6722 21.4363 12.6638C21.5205 12.6554 21.602 12.63 21.6761 12.5893C21.7502 12.5486 21.8152 12.4933 21.8673 12.4269C21.9194 12.3605 21.9574 12.2842 21.9791 12.2027C22.0008 12.1212 22.0057 12.0362 21.9935 11.9528L21.9546 11.5608C21.7635 9.65523 21.1121 7.82413 20.0561 6.22404C19.0001 4.62396 17.571 3.30248 15.8909 2.37259L15.411 2.10668ZM13.9427 5.45239C14.0283 5.31053 14.1669 5.20836 14.3281 5.16832C14.4892 5.12829 14.6598 5.15368 14.8021 5.23891L14.9575 5.33129C15.9688 5.93546 16.8364 6.75125 17.5002 7.72227C18.1641 8.6933 18.6084 9.7964 18.8025 10.9553L18.8576 11.2886C18.8738 11.3706 18.8734 11.455 18.8563 11.5368C18.8392 11.6186 18.8058 11.6961 18.7581 11.7648C18.7104 11.8335 18.6493 11.892 18.5785 11.9367C18.5076 11.9815 18.4285 12.0116 18.3458 12.0253C18.2631 12.039 18.1785 12.036 18.0969 12.0165C18.0154 11.9971 17.9386 11.9615 17.8711 11.9118C17.8037 11.8622 17.7469 11.7996 17.7041 11.7278C17.6614 11.6559 17.6336 11.5762 17.6223 11.4934L17.5659 11.1613C17.4021 10.1806 17.0266 9.24711 16.4653 8.42525C15.904 7.60338 15.1702 6.91277 14.3148 6.40117L14.1594 6.30879C14.0888 6.26666 14.0273 6.2111 13.9782 6.14526C13.9292 6.07942 13.8937 6.0046 13.8736 5.92507C13.8536 5.84554 13.8495 5.76286 13.8616 5.68176C13.8737 5.60065 13.9016 5.52271 13.9439 5.45239H13.9427Z"
                                      fill="white"/>
                                </svg>

                                {Language.getLabel('L_REQUEST_CALL')}
                              </button>
                            </div>
                          </React.Fragment>
                        }

                        {this.props.settings.useHandlers && this.props.settings.useHandlers[CodeSendHandlersIds.HANDLER_FLASHCALL] &&
                          <React.Fragment>
                            <div className="modal-verification-new__group">
                              <button className="btn-new btn-new--block"
                                      type="button"
                                      disabled={this.getPending()}
                                      tabIndex={this.getTabIndex()}
                                      onClick={(e) => {
                                        this.props.onHandleSelectMethod(e, 'flashcall')
                                      }}>
                                <svg className="icon icon--call" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M3.89489 2.58107C4.96482 1.98434 6.32917 1.84452 7.63338 2.1741C8.26857 2.33389 8.81105 2.74461 9.13679 3.31014L10.2618 5.26513C10.6628 5.9621 10.7786 6.78631 10.5852 7.56622C10.3917 8.34614 9.90391 9.02168 9.22324 9.45225L8.23349 10.0789C7.82381 10.3374 7.67347 10.7331 7.76743 11.0464C8.10319 12.1675 8.84613 13.4109 9.66298 14.2623C9.90603 14.517 10.352 14.5769 10.788 14.3235L11.3355 14.0051C11.6948 13.7965 12.0921 13.6612 12.5044 13.6072C12.9166 13.5532 13.3356 13.5815 13.7367 13.6905C14.1379 13.7995 14.5133 13.987 14.841 14.2421C15.1686 14.4971 15.4421 14.8147 15.6453 15.1761L16.6538 16.9676C16.9833 17.5543 17.0372 18.2547 16.8042 18.8851C16.3394 20.1373 15.4436 21.1472 14.3424 21.6528C13.2236 22.1659 11.9143 22.1447 10.7292 21.357C8.85239 20.1111 6.59101 18.0138 4.54261 14.5157C2.46791 10.9703 1.94547 7.95292 2.00435 5.70331C2.04194 4.26391 2.80617 3.1878 3.89489 2.58107ZM15.411 2.10668C15.2658 2.02623 15.0945 2.00654 14.9347 2.05196C14.775 2.09738 14.6398 2.20418 14.5591 2.34887C14.4783 2.49356 14.4586 2.66429 14.5042 2.82349C14.5498 2.98269 14.6569 3.11733 14.8021 3.19778L15.2832 3.46494C16.7862 4.29688 18.0646 5.47904 19.0093 6.9104C19.954 8.34175 20.5368 9.97974 20.708 11.6844L20.7481 12.0776C20.7529 12.1618 20.7747 12.2441 20.8122 12.3197C20.8497 12.3952 20.9022 12.4624 20.9665 12.5172C21.0308 12.572 21.1056 12.6132 21.1864 12.6384C21.2671 12.6636 21.3521 12.6722 21.4363 12.6638C21.5205 12.6554 21.602 12.63 21.6761 12.5893C21.7502 12.5486 21.8152 12.4933 21.8673 12.4269C21.9194 12.3605 21.9574 12.2842 21.9791 12.2027C22.0008 12.1212 22.0057 12.0362 21.9935 11.9528L21.9546 11.5608C21.7635 9.65523 21.1121 7.82413 20.0561 6.22404C19.0001 4.62396 17.571 3.30248 15.8909 2.37259L15.411 2.10668ZM13.9427 5.45239C14.0283 5.31053 14.1669 5.20836 14.3281 5.16832C14.4892 5.12829 14.6598 5.15368 14.8021 5.23891L14.9575 5.33129C15.9688 5.93546 16.8364 6.75125 17.5002 7.72227C18.1641 8.6933 18.6084 9.7964 18.8025 10.9553L18.8576 11.2886C18.8738 11.3706 18.8734 11.455 18.8563 11.5368C18.8392 11.6186 18.8058 11.6961 18.7581 11.7648C18.7104 11.8335 18.6493 11.892 18.5785 11.9367C18.5076 11.9815 18.4285 12.0116 18.3458 12.0253C18.2631 12.039 18.1785 12.036 18.0969 12.0165C18.0154 11.9971 17.9386 11.9615 17.8711 11.9118C17.8037 11.8622 17.7469 11.7996 17.7041 11.7278C17.6614 11.6559 17.6336 11.5762 17.6223 11.4934L17.5659 11.1613C17.4021 10.1806 17.0266 9.24711 16.4653 8.42525C15.904 7.60338 15.1702 6.91277 14.3148 6.40117L14.1594 6.30879C14.0888 6.26666 14.0273 6.2111 13.9782 6.14526C13.9292 6.07942 13.8937 6.0046 13.8736 5.92507C13.8536 5.84554 13.8495 5.76286 13.8616 5.68176C13.8737 5.60065 13.9016 5.52271 13.9439 5.45239H13.9427Z"
                                    fill="white"/>
                                </svg>

                                {Language.getLabel('L_REQUEST_CALL')}
                              </button>
                            </div>
                          </React.Fragment>
                        }
                      </form>
                    </div>
                  </div>
                )}

              </div>
            </div>
            {/* <div className="modal-footer modal-footer_no-content">
                        </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default ModalConfirmMethodsForm;